import { Grid } from 'jrgrid';
import { transferColumns } from '../../utils';
import { pageTransfers } from '../../api';
import Navbar from '../../../../components/Navbar';
import React, { Fragment } from 'react';
import { Loader } from '../../../../components/Loader';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FilterButtonFilter, FilterButtons } from '../../../Receiving/utils';
import { determineITAdmin } from '../components/determineITAdmin';

export const TransfersInitiatedPage = () => {
  const [refresh, setRefresh] = React.useState(false);
  const [itAdmin, setItAdmin] = React.useState(false);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));
  //   const [allDepts, setAllDepts] = React.useState(false);
  //   const [gridFilter, setGridFilter] = React.useState<FilterButtonFilter[]>([
  //     {
  //       id: 'updateType',
  //       type: 'string',
  //       operand: 'and',
  //       isLike: false,
  //       value: 'C',
  //     },
  //   ]);

  React.useEffect(() => {
    setItAdmin(determineITAdmin(user));
  }, []);

  //   const transferFilterButtons = [
  //     new FilterButtons(`To My Department (${user.currentRole?.departmentAbbreviation})`, 'primary', {
  //       id: 'toDeptId',
  //       type: 'number',
  //       operand: 'and',
  //       isLike: false,
  //       value: `${user.currentRole?.departmentId}`,
  //     }),
  //     new FilterButtons('Initiated', 'primary', {
  //       id: 'updateStatus',
  //       isLike: true,
  //       operand: 'and',
  //       type: 'string',
  //       value: '%initiated',
  //     }),
  //     new FilterButtons('Received', 'primary', {
  //       id: 'updateStatus',
  //       isLike: true,
  //       operand: 'and',
  //       type: 'string',
  //       value: '%received',
  //     }),
  //     new FilterButtons('Pending Approval', 'primary', {
  //       id: 'updateStatus',
  //       isLike: true,
  //       operand: 'and',
  //       type: 'string',
  //       value: '%approval',
  //     }),
  //     new FilterButtons('Errors', 'primary', {
  //       id: 'updateStatus',
  //       isLike: true,
  //       operand: 'and',
  //       type: 'string',
  //       value: '%error',
  //     }),
  //     new FilterButtons('Salvage', 'primary', {
  //       id: 'updateStatus',
  //       isLike: true,
  //       operand: 'and',
  //       type: 'string',
  //       value: '%salvage',
  //     }),
  //     new FilterButtons('Reset', 'danger', {
  //       id: 'updateStatus',
  //       isLike: true,
  //       operand: 'and',
  //       type: 'string',
  //       value: '',
  //     }),
  //   ];

  //   const interpretFilters = (gridFilter: any, filter: any) => {
  //     let message = '';

  //     const toDeptFilter = gridFilter.find((filterItem: any) => filterItem.id === 'toDeptId' && filterItem.value === '19');

  //     const departmentMessage = toDeptFilter ? 'Showing items only for OIT' : 'Showing items from all departments';

  //     const statusFilter = gridFilter.find((filterItem: any) => filterItem.value && filterItem.id !== 'toDeptId');

  //     if (statusFilter) {
  //       if (statusFilter.value === 'C') {
  //         message = `that are transfer records`;
  //       } else if (statusFilter.value) {
  //         message = `, with a status of ${statusFilter.value}`;
  //       } else {
  //         message = `, ${statusFilter.value}`;
  //       }
  //     }
  //     return departmentMessage + message;
  //   };

  const renderGrid = () => {
    //console.log(user);
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid...' />;
    } else {
      const filter = [
        {
          id: 'updateType',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: 'C',
        },

        {
          id: 'updateStatus',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: 'Transfer Initiated',
        },
      ];

      //further scope the transfered list to the individual department if
      //the user is *not* from it
      if (!itAdmin) {
        filter.push({
          id: 'toDeptId',
          type: 'number',
          operand: 'and',
          isLike: false,
          value: `${user.currentRole.departmentId}`,
        });
      }

      //   let filter: FilterButtonFilter[] = itAdmin
      //     ? []
      //     : [
      //         {
      //           id: 'toDeptId',
      //           type: 'number',
      //           operand: 'and',
      //           isLike: false,
      //           value: `${user.currentRole.departmentId}`,
      //         },
      //       ];

      //   console.log('grid filter: ', JSON.stringify(gridFilter ? [...gridFilter, ...filter] : [...filter]));

      return (
        <Grid
          amount={20}
          columns={transferColumns}
          query={pageTransfers}
          queryName='pageTransfers'
          defaultSortField='updateId'
          globalFilters={/* gridFilter ? [...gridFilter, ...filter] : [...filter] */ filter}
          refresh
        />
      );
    }
  };

  const includeAll = itAdmin ? 'viewing all in system' : 'to your department';

  return (
    <Fragment>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <h3 className='mt-3 mb-3 ml-2 mr-2'>
            Transfers Initiated <span className='badge badge-info'>{includeAll}</span>
          </h3>
        </Row>
        <div className='ml-2 mr-2'>{renderGrid()}</div>
      </div>
    </Fragment>
  );
};
